export const meetingPlatformOptions = {
  zoom: 'ZOOM',
  googleMeet: 'GMAIL',
  inPerson: 'INPERSON',
} as const;

const appointmentDurationOptions = {
  30: '30',
  45: '45',
  60: '60',
  90: '90',
  120: '120',
} as const;

export const appointmentPlatformOptions = [
  { value: meetingPlatformOptions.zoom, label: 'Zoom' },
  { value: meetingPlatformOptions.googleMeet, label: 'Google Meet' },
  { value: meetingPlatformOptions.inPerson, label: 'In Person' },
];

export const meetingDurationOptions = [
  { value: appointmentDurationOptions[30], label: '30 mins' },
  { value: appointmentDurationOptions[45], label: '45 mins' },
  { value: appointmentDurationOptions[60], label: '60 mins' },
  { value: appointmentDurationOptions[90], label: '90 mins' },
];
